export default __webpack_public_path__ + "static/media/animatorSlide.5574ec14.png";